// Hook listy WSZYSTKICH usług aktualnej wersji oferty (ze wszystkich pozycji) -
// GET /sales-crm/clients/:cid/offers/:oid/services

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

import type { OfferServicePriceType } from './useGetSalesCrmOfferServices';

export interface ISalesCrmOfferAllService {
  id: number;
  offerVersionPositionId: number;
  serviceId: number | null;
  name: string;
  priceNet: number | null;
  priceGross: number | null;
  priceNetFormatted: string | null;
  priceGrossFormatted: string | null;
  valueNet: number | null;
  valueGross: number | null;
  valueNetFormatted: string | null;
  valueGrossFormatted: string | null;
  currency: string | null;
  taxPercent: number | null;
  priceType: OfferServicePriceType | null;
  calcMethod: number | null;
}

export interface ISalesCrmOfferAllServicesResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: ISalesCrmOfferAllService[];
}

export const getSalesCrmOfferAllServicesQueryKey = (clientId: number, offerId: string) =>
  ['sales-crm', 'client', clientId, 'offer', offerId, 'services-all'] as const;

const getSalesCrmOfferAllServices = (
  clientId: number,
  offerId: string
): Promise<ISalesCrmOfferAllServicesResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}/services`);

export const useGetSalesCrmOfferAllServices = (
  clientId: number,
  offerId: string,
  options?: UseQueryOptions<ISalesCrmOfferAllServicesResponse, IError>
) =>
  useQuery<ISalesCrmOfferAllServicesResponse, IError>(
    getSalesCrmOfferAllServicesQueryKey(clientId, offerId),
    () => getSalesCrmOfferAllServices(clientId, offerId),
    {
      ...options,
      enabled:
        options?.enabled !== false && clientId > 0 && String(offerId).trim().length > 0
    }
  );
